const mobilePattern = /^(?:\+91[-\s]?|91[-\s]?|0)?[1-9]\d{9}$/;

export const vendorSchema = ({list}) => {
    const {
        items: expenseList,
        status: expenseListStatus,
    } = list.expense;

    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    if (!value || value.trim() === '') {
                        return 'Name is required';
                    }
                    return null;
                },
            },
            transactionType: {
                type: 'multiselect',
                label: 'Vendor type',
                options: expenseListStatus === "success" ? expenseList : {},
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!Array.isArray(value) || value.length === 0) return 'At least one type is required';
                    return null;
                },
            },
            dueDays: {
                type: 'text',
                label: 'Due days',
                columns: {sm: 12, md: 6},
                validation: (value) => {
                    if (!value || value === '') {
                        return 'Due days is required';
                    }
                    return null;
                },
            },
            contactInfo: {
                type: 'object',
                label: 'Contact info',
                properties: {
                    phone: {
                        type: 'text',
                        label: 'Mobile',
                        columns: {sm: 12, md: 6},
                        validation: (value) => {
                            if (value.trim() === '') return 'Mobile is required';
                            if (!mobilePattern.test(value)) return "Please enter a valid Indian phone number (e.g. 9876543210, +919876543210, 01722001234)";
                            return null;
                        }
                    },
                    address: {
                        type: 'object',
                        label: "Address",
                        properties: {
                            street: {
                                type: 'text',
                                label: 'Street',
                                columns: {md: 12, lg: 6},
                                validation: (value) => {
                                    if (!value) return null;
                                },
                            },
                            city: {
                                type: 'text',
                                label: 'City',
                                columns: {md: 12, lg: 6},
                                validation: (value) => {
                                    if (!value) return null;
                                },
                            },
                            state: {
                                type: 'text',
                                label: 'State',
                                columns: {md: 12, lg: 6},
                                validation: (value) => {
                                    if (!value) return null;
                                },
                            },
                            zipCode: {
                                type: 'text',
                                label: 'ZipCode',
                                columns: {md: 12, lg: 6},
                                validation: (value) => {
                                    if (!value) return null;
                                },
                            },
                        }
                    }
                }
            },
        }
    )
}